import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";
import { ElementGroup } from "../elements";
import { DesignElementSnapshotBase, pickLatestSnapshots } from "./base";

/**
 * Snapshot of an element group.
 *
 * Please note that existence of snapshot's references (including parent persistent id) is not guaranteed.
 */
export const ElementGroupSnapshot = DesignElementSnapshotBase.extend({
  group: ElementGroup,
});

export type ElementGroupSnapshot = z.infer<typeof ElementGroupSnapshot>;

export type CreateElementGroupSnapshot = DbCreateInputOmit<ElementGroupSnapshot>;
export type UpdateElementGroupSnapshot = OmitStrict<DbUpdate<ElementGroupSnapshot>, "designSystemVersionId">;

//
// Util functions
//

export function pickLatestGroupSnapshots(snapshots: ElementGroupSnapshot[]): ElementGroupSnapshot[] {
  return pickLatestSnapshots(snapshots, s => s.group.id);
}
